import { drfRequest } from '@/services/drfRequest'

export interface TagSuggestion {
  id: string
  conversation_id: string
  tag: { id: string; name: string; color?: string }
  probability: number | null
  message_id: string | null
  message_text: string | null
  status: 'pendiente' | 'confirmada' | 'descartada'
  created_at: string
}

export const tagSuggestionsService = {
  list(conversationId: string) {
    return drfRequest<TagSuggestion[]>(`/api/v1/tags/suggestions/?conversation_id=${encodeURIComponent(conversationId)}`)
  },
  decide(id: string, action: 'confirm' | 'discard') {
    return drfRequest<TagSuggestion>(`/api/v1/tags/suggestions/${id}/`, {
      method: 'POST',
      body: JSON.stringify({ action }),
    })
  },
}
